import { Icon } from "@iconify/react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../utils/apiClient";
import { toast } from "react-toastify";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            const response = await api.post("/forgot-password", { email });

            if (response.data.status) {
                toast.success(response.data.message || "Reset link sent!");
            } else {
                setError(response.data.message || "Email not found");
            }
        } catch (err) {
            setError(err.response?.data?.message || "Server not reachable");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="auth bg-base d-flex flex-wrap " >
            <div className="auth-right py-32 px-24 d-flex flex-column align-items-center justify-content-center w-100">
                <div className="max-w-464-px mx-auto w-100">
                    <div className="center-all" >
                        <div className="logo-wrapper">
                            <img src="/assets/images/app_logo.webp" alt="Logo" />
                        </div>
                        <h5 className="mb-12">Forgot Password</h5>
                    </div>

                    {error && <p className="text-danger mb-16">{error}</p>}

                    <form onSubmit={handleSubmit}>
                        <div className="icon-field mt-16">
                            <span className="icon top-50 translate-middle-y">
                                <Icon icon="mage:email" />
                            </span>
                            <input
                                type="email"
                                name="email"
                                className="form-control h-56-px bg-neutral-50 radius-12"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>


                        <button
                            type="submit"
                            className="btn btn-primary text-sm btn-sm px-10 py-10 w-100 radius-12 mt-3"
                            disabled={loading}
                        >
                            {loading ? "Sending..." : "Send email"}
                        </button>
                        <p className="text-center mt-3">Back to <Link to="/" className="text-primary-600 fw-medium">
                            Log in
                        </Link> </p>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default ForgotPassword;